import * as React from "react";
const SvgTriangleDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 5, viewBox: "0 0 8 5", fill: "#182A52", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 4.5L8 0H0L4 4.5Z" }));
export default SvgTriangleDown;
